export enum AccountRoleType {
  Other,
  Member,
  AccountOwner
}
